import styled from "styled-components";

export const DirectionItem = styled("li")(({ theme }) => ({
  marginBottom: 8,

  "& a": {
    color: "#4299e1",
    textDecoration: "none",
    padding: "8px 12px",
    borderRadius: 6,
    display: "block",
    transition: "background-color 0.2s ease",

    "&:hover": {
      backgroundColor: "#ebf8ff",
      color: "#2b6cb0",
    },
  },
}));

export const DirectionList = styled("ul")(({ theme }) => ({
  listStyle: "none",
  padding: 0,
  margin: 0,

  display: "grid",
  gridTemplateColumns: "repeat(3,1fr)",
  gap: 20,

  [theme.down("xs")]: {
    gridTemplateColumns: "repeat(2,1fr)",
  },
}));
